import classNames from 'classnames';
import React, { FC } from 'react';
import type { PieceType } from '@whitesharx/starfall-frontend-chessground';

import { PlayerColor } from '../../types';

import FigureGroup from './FigureGroup';

import { containerStyles, figuresBarStyles } from './styles.css';

export type Figures = Record<PieceType, number>;

type FiguresBarProps = {
  color: PlayerColor;
  reverse?: boolean;
  setName?: string;
  figures: Figures;
};

const FiguresBar: FC<FiguresBarProps> = ({ color, reverse, setName, figures }) => (
  <div className={classNames(containerStyles, figuresBarStyles[reverse ? 'reverse' : 'default'])}>
    {Object.entries(figures).map(([figure, count], index) => {
      if (count > 0) {
        return (
          <FigureGroup
            name={figure}
            color={color}
            count={count}
            reverse={reverse}
            key={figure + index}
            setName={setName}
          />
        );
      }
    })}
  </div>
);

export default FiguresBar;
